import { useRef, useState } from "react"

export function useStateWithGetter<T>(defaultValue: T) {
  const ref = useRef<T>(defaultValue)
  const [_, setReloadKey] = useState(1)

  function setValue(newValue: T | ((oldValue: T) => T)) {
    const actualNewValue =
      typeof newValue === "function" ? (newValue as any)(ref.current) : newValue

    if (ref.current !== actualNewValue) {
      ref.current = actualNewValue
      setReloadKey(key => key + 1)
    }
  }

  return [ref.current, setValue, () => ref.current] as const
}
